import { fullfillClicksDataLayer, fullfillImpressionsDataLayer } from 'src/utils/analytics/dataLayer';


const collectClick = (event, offer, list) => {
  event.preventDefault();

  const clickData = {
    name: offer.jobTitle,
    id: `${offer.offerId}`,
    price: '1',
    brand: offer.companyName,
    category: '',
    variant: offer.workplace,
    position: `${offer.position + 1}`,
    dimension6: '',
    dimension7: offer.isSuperOffer ? 'Tak' : 'Nie',
    dimension8: '',
    dimension9: '',
    dimension10: ''
  };
  fullfillClicksDataLayer(list, clickData);

  window.location.assign(offer.offerUrl);
};

const collectImpressions = (offers, list) => {
  const impressions = offers.map((offer, index) => ({
    name: offer.jobTitle,
    id: `${offer.offerId}`,
    price: '1',
    brand: offer.companyName,
    category: '',
    variant: offer.workplace,
    list,
    position: `${index + 1}`,
    dimension6: '',
    dimension7: offer.isSuperOffer ? 'Tak' : 'Nie',
    dimension8: '',
    dimension9: '',
    dimension10: ''
  }));

  fullfillImpressionsDataLayer(impressions);
};

export {
  collectImpressions,
  collectClick
};
